import { FILModal } from './modal';

export class FILLoginFromToolModal extends FILModal {
  checkEnv() {}
}
